/*!
 * (c) 2026 Ocean Essentials Limited (HK). All rights reserved.
 * Proprietary code. Licensed, not sold. See LICENSE.md and Services Agreement.
 */

(function () {
  function showCompareLimitToast(checkbox) {
    var card = checkbox.closest("[data-product-card]");
    if (!card) return;

    var toast = card.querySelector("[data-compare-toast]");
    if (!toast) return;

    if (toast.dataset.hideTimer) {
      clearTimeout(Number(toast.dataset.hideTimer));
    }

    toast.hidden = false;
    window.requestAnimationFrame(function () {
      toast.classList.add("is-visible");
    });

    var timer = window.setTimeout(function () {
      toast.classList.remove("is-visible");
      window.setTimeout(function () {
        toast.hidden = true;
      }, 160);
    }, 2400);
    toast.dataset.hideTimer = String(timer);
  }

  function initProductCards2026() {
    // ==========================================================================
    // COMPARE CHECKBOX FUNCTIONALITY
    // Delegated to compare-2026.js when the unified compare page is enabled.
    // ==========================================================================
    if (!(window.exocetCompareConfig && window.exocetCompareConfig.enabled)) {
      document.querySelectorAll("[data-compare-checkbox]:not([data-product-card-bound])").forEach(function (checkbox) {
        checkbox.dataset.productCardBound = "true";

        checkbox.addEventListener("click", function (event) {
          var checkedCount = document.querySelectorAll("[data-compare-checkbox]:checked").length;
          if (this.checked && checkedCount > 3) {
            event.preventDefault();
            this.checked = false;
            showCompareLimitToast(this);
          }
        });

        checkbox.addEventListener("change", function () {
          var card = this.closest("[data-product-card]");
          var productId = this.dataset.productId || this.value;

          if (this.checked) {
            var checked = document.querySelectorAll("[data-compare-checkbox]:checked");
            if (checked.length > 3) {
              this.checked = false;
              showCompareLimitToast(this);
              return;
            }
          }

          if (card) {
            if (this.checked) {
              card.classList.add("is-selected");
            } else {
              card.classList.remove("is-selected");
            }
          }

          var allChecked = document.querySelectorAll("[data-compare-checkbox]:checked");
          document.dispatchEvent(
            new CustomEvent("compare:updated", {
              detail: {
                count: allChecked.length,
                productIds: Array.prototype.map.call(allChecked, function (cb) {
                  return cb.dataset.productId || cb.value;
                }),
              },
            }),
          );
        });
      });
    }

    // ==========================================================================
    // SIZE CHIP SELECTION (in content area)
    // ==========================================================================
    document
      .querySelectorAll(".size-chip:not(.is-unavailable):not([data-product-card-bound])")
      .forEach(function (chip) {
        chip.dataset.productCardBound = "true";
        chip.addEventListener("click", function () {
          var sizes = this.closest(".product-card-2026__sizes");
          if (!sizes) return;
          sizes.querySelectorAll(".size-chip").forEach(function (c) {
            c.classList.remove("is-selected");
          });
          this.classList.add("is-selected");
        });
      });

    // ==========================================================================
    // QUICK ADD SIZE BUTTONS (interactive variant)
    // ==========================================================================
    document
      .querySelectorAll(".product-card-2026 [data-add-to-cart]:not([data-product-card-bound])")
      .forEach(function (btn) {
        btn.dataset.productCardBound = "true";
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (this.disabled || this.classList.contains("is-unavailable") || !this.dataset.variantId) return;
          if (this.closest("#ProductForm-2026")) return;

          var variantId = this.dataset.variantId;
          var variantTitle = this.dataset.variantTitle;
          var productTitle = this.dataset.productTitle;
          var button = this;
          var card = this.closest(".product-card-2026");
          var confirmation = card.querySelector("[data-added-confirmation]");
          var productNameEl = card.querySelector("[data-added-product-name]");
          var originalText = button.textContent;

          var errorEl = card.querySelector("[data-cart-error]");
          if (!errorEl) {
            errorEl = document.createElement("p");
            errorEl.setAttribute("data-cart-error", "");
            errorEl.setAttribute("role", "alert");
            card.appendChild(errorEl);
          }
          errorEl.hidden = true;
          // Loading state
          button.disabled = true;
          button.textContent = "...";

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
            }),
          })
            .then(function (response) {
              if (!response.ok) throw new Error("Cart request failed");
              return response.json();
            })
            .then(function (data) {
              if (data.status) {
                throw new Error(data.description || data.message || "Could not add to cart");
              }

              // Show success state on button
              button.classList.add("is-added");
              button.textContent = originalText + " \u2713";

              // Show confirmation overlay
              if (confirmation && productNameEl) {
                productNameEl.textContent = productTitle + " - " + variantTitle;
                confirmation.hidden = false;

                // Hide confirmation after 2 seconds
                setTimeout(function () {
                  confirmation.hidden = true;
                }, 2000);
              }

              // Dispatch event
              document.dispatchEvent(
                new CustomEvent("product-card-2026:added", {
                  detail: { variantId: variantId, productTitle: productTitle, variantTitle: variantTitle },
                }),
              );

              document.dispatchEvent(new CustomEvent("cart:add", { detail: data }));
              document.dispatchEvent(new CustomEvent("cart:open"));

              // Reset button after 2 seconds
              setTimeout(function () {
                button.classList.remove("is-added");
                button.textContent = originalText;
                button.disabled = false;
              }, 2000);
            })
            .catch(function () {
              errorEl.textContent = window.cartStrings?.error || "";
              errorEl.hidden = false;
              button.textContent = originalText;
              button.disabled = false;
            });
        });
      });
  }

  window.initProductCards2026 = initProductCards2026;

  if (window.productCardInitialized) {
    initProductCards2026();
    return;
  }

  window.productCardInitialized = true;
  document.addEventListener("shopify:section:load", initProductCards2026);
  var observer = new MutationObserver(function (records) {
    if (records.some(function (record) {
      return Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && (node.matches(".product-card-2026") || node.querySelector(".product-card-2026"));
      });
    })) initProductCards2026();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductCards2026);
  } else {
    initProductCards2026();
  }
})();
